export default __webpack_public_path__ + "static/media/auditTrail.616841c3.svg";